import { Map } from 'immutable';
import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import {
  NormalizedVideoUpload,
  videoSchema,
} from 'redux/middleware/api/media-upload-service';
import { State } from 'redux/types';
import { DeepImmutableMap } from 'types';
import { entitiesSelector } from './base';

export type VideosById = Map<string, DeepImmutableMap<NormalizedVideoUpload>>;

export const videosSelector = (state: State) =>
  entitiesSelector(state).get('videos');

export const videosByIdSelector = createSelector(
  videosSelector,
  (videos): VideosById => denormalize(videos, videoSchema, Map()),
);

export const videoSelector = createSelector(
  videosByIdSelector,
  (_, id: string | number) => id,
  (videosById, id) => videosById.get(String(id)),
);
